import React from "react";
import { Radio as AntRadio, RadioGroupProps as AntRadioGroupProps } from "antd";
import styled from "styled-components";
import { RadioOption } from "./interfaces";

const { Group } = AntRadio;

export interface RadioGroupProps extends AntRadioGroupProps {
  options?: RadioOption[];
}

const RadioGroup: React.FC<RadioGroupProps> = (props: RadioGroupProps) => {
  const { options = [], value, ...rest } = props;

  return (
    <StyledRadioGroup value={value} style={{ color: "black" }} {...rest}>
      {options.map((val) => {
        return (
          <AntRadio key={val.value} value={val.value}>
            {val.label}
          </AntRadio>
        );
      })}
    </StyledRadioGroup>
  );
};

export default RadioGroup;

const StyledRadioGroup = styled(Group)`
  height: 32px;
  .ant-radio-disabled + span {
    color: black;
  }
`;
